module.exports = __webpack_public_path__ + "img/finland-transport-accidents-female.40dd7eed.png";